import * as React from 'react';
import { IconChevronRight12, Spinner, UIHeading2, UIText2 } from '@cian/ui-kit';
import { mergeStyles } from '@cian/utils';
import { TVillageListPageStoreProps } from '../../containers/VillageListPage';
import { BreadcrumbsContainer } from '../../containers/BreadcrumbsContainer';
import { MobileFiltersContainer } from '../mobile/filters/container';
import { MobileListContainer } from '../mobile/list/container';
import { ScrollFolding } from '../../utils/scroll_folding';
import { FeedbackContainer } from '../feedback/container';
import * as styles from './MobileVillageListPage.css';
import { SeoMarkedListContainer } from '../../containers/SeoMarkedListContainer';
import { SortingContainerMobile } from '../../containers/SortingContainer';

const HEIGHT_OF_FILTER_BLOCK = 50;

interface IMobileVillageListPageState {
  top: string;
}

export class MobileVillageListPage extends React.Component<TVillageListPageStoreProps, IMobileVillageListPageState> {
  private header: HTMLElement | null = null;
  public state = {
    top: '0px',
  };
  /*
    Чтобы не модифицировать код в репозитории шапки и не аффектить на другие проекты,
    было принято решение добавить логику по прилипанию шапки только в данном проекте.
  */
  private onFoldChange = (hidden: boolean) => {
    if (!this.header) {
      return;
    }

    if (hidden) {
      this.header.style.top = `-${this.header.offsetHeight + HEIGHT_OF_FILTER_BLOCK}px`;
      this.setState({ top: `-${HEIGHT_OF_FILTER_BLOCK}px` });
    } else {
      this.header.style.top = '0';
      this.setState({ top: `${this.header.offsetHeight}px` });
    }
  };

  public componentDidMount() {
    this.header = document.getElementById('adaptive-header');
    if (this.header) {
      this.header.classList.add(styles['adaptive-header']);
      this.setState({ top: `${this.header.offsetHeight}px` });
    }
  }

  public render() {
    const { isFetching, pageHeading, totalItems, villageList } = this.props;

    return (
      <div className={styles['container']}>
        {isFetching && (
          <div className={styles['preload-overlay']}>
            <div className={styles['preloader']}>
              <Spinner />
            </div>
          </div>
        )}
        <ScrollFolding onFoldChange={this.onFoldChange}>
          <MobileFiltersContainer {...mergeStyles(styles['header-fixed'], { top: this.state.top })} />
        </ScrollFolding>
        <div className={styles['village-list']}>
          <div className={styles['heading']}>
            <UIHeading2 as="h1">{pageHeading}</UIHeading2>
          </div>
          {!!villageList.length && (
            <>
              <div className={styles['summary']}>
                <UIText2>{totalItems}</UIText2>
                <SortingContainerMobile />
              </div>
              <FeedbackContainer />
            </>
          )}
          <MobileListContainer />
          <SeoMarkedListContainer />
        </div>
        <div className={styles['breadcrumbs']}>
          <BreadcrumbsContainer
            divider={
              <div className={styles['breadcrumbs-divider']}>
                <IconChevronRight12 color="gray60_100" />
              </div>
            }
          />
        </div>
      </div>
    );
  }
}
